<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>A Letter from Nero Blanc</span></p>
<p class="normal">Dear Friends,</p>
<p class="indent"><i>Another Word for Murder</i> is our tenth collaboration as Nero Blanc. It’s absolutely fitting that our wonderful cover artist, Grace DeVito, should put a clock on the jacket. Time does fly when you’re having fun.</p>
<p class="indent">We’re often asked how a husband and wife can write together without harboring lethal thoughts about one another, and our response is always: good communication. As former actors, we value collaboration in the creative process; in fact, we began the series because we wanted to work as partners once again. Each of us has different gifts, and when one of us is in a slump, the other’s in fine fettle. We become our own tag team, cheering each other on.</p>
<p class="indent">A big thank you to all our readers for making the journey so pleasurable. Thank you for your letters of encouragement, your thoughtful queries, and your genuine interest in Rosco, Belle, Al, Sara, Abe, and the gang. Remember our website <a href="http://www.CrosswordMysteries.com" target="_blank">www.CrosswordMysteries.com</a> has puzzles to download.</p>
<p class="indent">Cheers—and, yes, we’re hard at work on another Nero!</p>
<p class="right"><span>Please write to us soon,<br/>Cordelia and Steve</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?0c1f5852